import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/sxCorrectError/page',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function getObj (id) {
  return axios({
    url: `/sxCorrectError/${id}`,
    method: 'GET'
  })
}

export function addObj (params) {
  return axios({
    url: `/sxCorrectError/save`,
    method: 'POST',
    data: {
      ...params
    }
  })
}

export function putObj (params) {
  return axios({
    url: `/sxCorrectError/update`,
    method: 'POST',
    data: {
      ...params
    }
  })
}

export function delObj (id) {
  return axios({
    url: `/sxCorrectError/${id}`,
    method: 'DELETE'
  })
}

export function addComment (params) {
  return axios({
    url: `/sxCorrectError/saveComment`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
// 获取纠偏的列表，首页使用
export function getCorrectErrorList (data) {
  return axios({
    url: `/sxCorrectError/list`,
    method: 'GET',
    params: {
      ...data
    }
  })
}

// 更改状态
export function solveError (id) {
  return axios({
    url: `/sxCorrectError/solve/${id}`,
    method: 'GET'
  })
}
